// extracted by mini-css-extract-plugin
export var walletButton = "S_dY";
export var textAmountWhole = "S_dZ";
export var textAmountDecimal = "S_d0";
export var textCurrency = "S_d1";
export var selected = "S_d2";
export var rotate = "S_c";
export var dotty = "S_d";